
    <div class="row preloader-row" *ngIf="!isLoaded">
      <div class="col-12 text-center preloader-col">
        <i class="fa fa-spinner fa-pulse preload-spinner"></i>
      </div>
    </div>
    <ng-content *ngIf="isLoaded"></ng-content>
  